import React from 'react';
const paths = {
  search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></>,
  sort: <path d="m8 9 4-4 4 4m-8 6 4 4 4-4" />,
  more: <><circle cx="5" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /></>,
  plus: <path d="M12 5v14M5 12h14" />, arrow: <path d="M4 12h15m-6-6 6 6-6 6" />,
  refresh: <path d="M20 7v5h-5M4 17v-5h5m-5 0a8 8 0 0 1 14-5l2 2m0 3a8 8 0 0 1-14 5l-2-2" />,
  warning: <path d="m12 3 10 18H2L12 3Zm0 6v5m0 3h.01" />,
  copy: <><rect x="8" y="8" width="13" height="13" rx="2" /><path d="M15 8V3H3v12h5" /></>,
  trash: <path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7" />,
  left: <path d="m15 5-7 7 7 7" />, right: <path d="m9 5 7 7-7 7" />
};
export default function CampaignIcon({ name }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
